import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import VehicleList from "../VehicleList";
import { getFirestore } from "../../config/firebase";
import Loading from "../Loading/Loading";

const Main = ({ vehicles, loading }) => {
  return (
    <Container fluid="xl">
      <Row>
        <Col md={12}>{loading ? <Loading styles="mt-5 pt-5 pb-5" /> : <VehicleList vehicles={vehicles} />}</Col>
      </Row>
    </Container>
  );
};

export default Main;
